
import { NgModule } from '@angular/core';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { SharedModule } from 'lib-trend-core';
import { AttendanceWhisperModule } from '../attendance-whisper/attendance-whisper.module';
import { MenuActionsModule } from '../menu-actions/menu-actions.module';
import { WaTemplateModule } from '../wa-template/wa-template.module';
import { ChatMessageButtonsComponent } from './chat-messages/chat-message-buttons/chat-message-buttons.component';
import { ChatMessageContactComponent } from './chat-messages/chat-message-contact/chat-message-contact.component';
import { ChatMessageInteractiveReplayButtonComponent } from './chat-messages/chat-message-interactive-replay-button/chat-message-interactive-replay-button.component';
import { ChatMessageLocationComponent } from './chat-messages/chat-message-location/chat-message-location.component';
import { ChatMessageReactionsComponent } from './chat-messages/chat-message-reactions/chat-message-reactions.component';
import { ChatMessageReplyComponent } from './chat-messages/chat-message-reply/chat-message-reply.component';
import { ChatMessageScheduleComponent } from './chat-messages/chat-message-schedule/chat-message-schedule';
import { ChatMessageScheduleListComponent } from './chat-messages/chat-message-schedule/chat-message-schedule-list/chat-message-schedule-list';
import { ChatMessageComponent } from './chat-messages/chat-messages.component';
import { ChatTemplateScheduleComponent } from './chat-messages/chat-template-schedule/chat-template-schedule.component';
import { ChatSelectTemplateComponent } from './chat-select-template/chat-select-template.component';

@NgModule({
  imports: [
    SharedModule,
    WaTemplateModule,
    PickerModule,
    MenuActionsModule,
    AttendanceWhisperModule,
  ],
  declarations: [
    ChatMessageComponent,
    ChatSelectTemplateComponent,
    ChatMessageReactionsComponent,
    ChatMessageReplyComponent,
    ChatMessageScheduleComponent,
    ChatTemplateScheduleComponent,
    ChatMessageScheduleListComponent,
    ChatMessageContactComponent,
    ChatMessageLocationComponent,
    ChatMessageButtonsComponent,
    ChatMessageInteractiveReplayButtonComponent,
  ],
  exports: [
    ChatMessageComponent,
    ChatSelectTemplateComponent,
    ChatMessageReactionsComponent,
    ChatMessageReplyComponent,
    ChatMessageInteractiveReplayButtonComponent,
  ],
  providers: [],
})
export class ChatModule { }
